import React from 'react';

import { FitzyTitle } from './Title.styled.js';

const Title = ({ children }) => {
  return <FitzyTitle>{children}</FitzyTitle>;
};

export default Title;
